import componentShell from "./shell"
import SignTagExamples from "@/client/components/signs/sign_tag_examples"

export default componentShell(SignTagExamples)
